<template>
  <div class="editor-wrapper clearfix">
    <div id="editor-holder"></div>

    <div class="save-button-container" v-if="editor">
      <div class="container">
        <div class="success-message" v-if="successMessage" v-html="successMessage"></div>
        <button @click="saveForm" class="btn btn-primary pull-right" :disabled="isCurrentTenantInactive()">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const editors = require('@/libs/values-jsoneditor.js')

export default {
  data() {
    return {
      editor: null,
      savedJson: '',
      successMessage: null,
      errorMessage: null
    }
  },
  computed: {
    ...mapGetters(['editorData', 'isAdmin', 'sectionSelected', 'currentTenant', 'userTenants'])
  },
  created() {
    this.getData()
  },
  methods: {
    saveForm(event) {
      let editorValue = this.editor.getValue()

      this.savedJson = JSON.stringify(editorValue, null, 2)
      this.$store.dispatch('updateValues', editorValue).then(response => {
        this.$store.dispatch('showMessage', {
          title: 'Save',
          text: 'Changes saved successfully',
          type: 'success'
        })
      })
    },
    setValueEditor(val) {
      if (val == null || val.schema == null || val.values == null) {
        this.$store.dispatch('showMessage', {
          title: 'Save',
          text: 'No data found for tenant',
          type: 'error'
        })
        return
      }
      this.resetOutput()
      if (this.editor != null) {
        this.editor.destroy()
      }
      this.editor = new editors.JsonEditor(document.getElementById('editor-holder'), {
        schema: val.schema,
        ajax: true,
        no_additional_properties: true,
        startval: val.values,
        theme: 'bootstrap3',
        // disable_collapse: true,
        disable_array_add: false,
        disable_array_delete: false,
        disable_array_reorder: false,
        // disable_edit_json: !this.isAdmin,
        disable_properties: !this.isAdmin
      })
      let errors = this.editor.validate()
      if (errors.length) {
        //TODO show errors
        console.log('errors')
      }
    },
    resetOutput() {
      this.showOutput = false
      this.savedJson = ''
    },
    getData() {
      this.$store.dispatch('getEditorData')
      this.$store.commit('clearSectionSelected')
    },
    isCurrentTenantInactive() {
      //userTenants are not being fetched for non admins
      if (!this.isAdmin) return false

      const tenantInfo = this.userTenants.find(t => t.identifier === this.currentTenant)
      return tenantInfo != null ? tenantInfo.inactive : true
    }
  },
  watch: {
    editorData(val, oldVal) {
      this.setValueEditor(val)
    },
    sectionSelected(val, oldVal) {
      if (val) this.getData()
    }
  }
}
</script>

<style scoped>
.editor-wrapper {
  margin-bottom: 20px;
  clear: both;
}
.saved-json {
  height: 700px;
  width: 700px;
}
.save-button-container {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 15px 0;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 10;
}
</style>
<style>
#editor-holder > div > .well > div > div > .row > .col-md-12 > h3 > span {
  font-size: 130%;
}
#editor-holder > div > .well {
  background: #ddd;
}
.row > div > .well {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ValueEditor.vue